import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'react';
import { TradePlanData } from '../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../colorVars';
import { Body4, fontSizes } from '../../../../../../atomic/text/Text';
import { ExpirationDateSelector } from '../ExpirationDateSelector';
import style from './OptionChainsContainer.module.css';
import { requestOptionChains } from '../../../../../../../stores/websocketStore/utils/outgoingMessages/optionchains/requestOptionChains';
import { BorderAndLabel } from '../../../../../../atomic/atomicComponentLibrary/utility/borderAndLabel/BorderAndLabel';
import { OptionChainsTable } from './OptionChainsTable';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { resolveMarketDataBrokerage } from '../../../../../../../utils/accountRouting';

type Option = {
  value: string;
  label: string;
};
export const OptionChainsContainer = observer(() => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const { accountBalanceStore } = useWebsocketStore();
  const optionManagement = tradePlanForm.optionManagement;
  const notExpiringToday = optionManagement.notExpiringToday;
  const expirationDates = optionManagement.expirationDates ?? [];
  const selectedExpirationDates = optionManagement.selectedExpirationDates;
  const requestKey = optionManagement.requestKey;
  const symbol = tradePlanForm.symbol;
  const dataSource = tradePlanForm.dataSource;
  const accounts =
    Object.keys(accountBalanceStore.balances).map((accountNumber) => {
      const balance = accountBalanceStore.balances[accountNumber];
      return {
        accountNumber,
        brokerage: balance?.brokerage,
      };
    }) ?? [];
  const brokerage = resolveMarketDataBrokerage({
    accountNumber: tradePlanForm.accountNumber,
    accounts,
    currentBrokerage: tradePlanForm.brokerage,
    dataSource,
    symbol,
  });

  // const intervalRef = useRef(null);

  useEffect(() => {
    // if (intervalRef.current) {
    //   clearInterval(intervalRef.current);
    // }
    const selectedDates: string[] = selectedExpirationDates.map(
      (obj: Option) => obj.value
    );
    requestOptionChains(
      requestKey,
      selectedDates,
      symbol,
      dataSource,
      brokerage,
      tradePlanForm.accountNumber
    );
    // intervalRef.current = setInterval(
    //   () => requestOptionChains(requestKey, selectedDates, symbol, dataSource, brokerage),
    //   10000
    // );
    // return () => {
    //   if (intervalRef.current) clearInterval(intervalRef.current);
    // };
  }, [dataSource, requestKey, selectedExpirationDates, symbol, brokerage, tradePlanForm.accountNumber]);

  return (
    <BorderAndLabel
      backgroundColor="black"
      margin="10px 0 0 10px"
      label="Option Chains"
      color="white"
      fontSize={fontSizes.body3}
    >
      <div className={style.innerDiv}>
        <div className={style.topRow}>
          <ExpirationDateSelector
            expirationDates={expirationDates}
            selectedDates={selectedExpirationDates}
            setSelectedDates={optionManagement.setSelectedExpirationDates}
          />
          <div className={style.labelAndCheckbox}>
            <input
              style={{ margin: '3px 5px 0 5px' }}
              type="checkbox"
              checked={notExpiringToday}
              onChange={() => {
                tradePlanForm.optionManagement.setNotExpiringToday(
                  !notExpiringToday
                );
              }}
            />
            <Body4 color={colors.lightGrey} fontWeight={500}>
              Not Expiring Today
            </Body4>
          </div>
        </div>
        <OptionChainsTable />
      </div>
    </BorderAndLabel>
  );
});

// add expiration date selector, not expiring today and option chains table
